export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000/accounting/api/v1'
};

// Endpoints disponibles via l'API Gateway (production)
// https://api.wanzzo.com/accounting/api/v1/*  → accounting-service
// https://api.wanzzo.com/ai/*                  → adha-ai-service
// https://api.wanzzo.com/admin/*               → admin-service
// https://api.wanzzo.com/analytics/*           → analytics-service
//
// L'API Gateway route /accounting/api/v1/* vers accounting-service
// qui expose les endpoints: /settings, /settings/data-sharing, /settings/data-sources, etc.